import { memo } from 'react';
import { IconSuccess } from '@divlab/divanui/icons';

import useMedias from '@Hooks/useMedias';
import useTranslation from '@Queries/useTranslation';
import styles from './TariffAdvantages.module.css';

import type { FC, HTMLAttributes } from 'react';

interface TariffAdvantagesProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  advantages: string[];
}

const TariffAdvantages: FC<TariffAdvantagesProps> = (props) => {
  const { advantages, ...restProps } = props;
  const { isDesktop, isMobile } = useMedias();
  const { t } = useTranslation();

  return (
    <div {...restProps}>
      {isDesktop && !isMobile && <div className={styles.title}>{t('includes')}</div>}
      {advantages.map((advantage, index) => {
        return (
          <div key={index} className={styles.advantage}>
            <IconSuccess className={styles.icon} />
            <span className={styles.text}>{advantage}</span>
          </div>
        );
      })}
    </div>
  );
};

export default memo(TariffAdvantages);
